import i18next from 'i18next'
import { DeliveryModel } from '@audibene/ta.utils-opportunity'
import { AppointmentCancellationReason, Country, TechSetupFailureReason, networkDeliveryModels } from '../../../../../constants'

type PrimaryAppointmentCancellationReason = 'CUSTOMER_NOT_INTERESTED' | 'OTHER' | 'TECH_SETUP_FAILED'

const PrimaryAppointmentCancellationReason: Record<PrimaryAppointmentCancellationReason, PrimaryAppointmentCancellationReason> = {
  CUSTOMER_NOT_INTERESTED: 'CUSTOMER_NOT_INTERESTED',
  OTHER: 'OTHER',
  TECH_SETUP_FAILED: 'TECH_SETUP_FAILED',
} as const

type PrimaryAppointmentCancellationReasonDE = 'CUSTOMER' | 'PARTNER' | 'TECH' | 'TECH_SETUP_INCOMPLETE'

const PrimaryAppointmentCancellationReasonDE: Record<PrimaryAppointmentCancellationReasonDE, PrimaryAppointmentCancellationReasonDE> = {
  CUSTOMER: 'CUSTOMER',
  PARTNER: 'PARTNER',
  TECH: 'TECH',
  TECH_SETUP_INCOMPLETE: 'TECH_SETUP_INCOMPLETE',
} as const

const primaryReasonDisplayText: Record<PrimaryAppointmentCancellationReason, string> = {
  CUSTOMER_NOT_INTERESTED: i18next.t('pages.appointment.cancel.reason.customerNotInterested'),
  TECH_SETUP_FAILED: i18next.t('pages.appointment.cancel.reason.techSetupFailed'),
  OTHER: i18next.t('pages.appointment.cancel.reason.other'),
} as const

const primaryReasonDisplayTextDE: Record<PrimaryAppointmentCancellationReasonDE, string> = {
  CUSTOMER: i18next.t('pages.appointment.reason.customer'),
  PARTNER: i18next.t('pages.appointment.reason.partner'),
  TECH: i18next.t('pages.appointment.reason.tech'),
  TECH_SETUP_INCOMPLETE: i18next.t('pages.appointment.reason.techSetupIncomplete'),
} as const

const networkCancellationReasons = [
  AppointmentCancellationReason.NOT_MOVING_FORWARD,
  AppointmentCancellationReason.COST_INSURANCE,
  AppointmentCancellationReason.PERSONAL_HEALTH,
  AppointmentCancellationReason.TRAVEL_TRANSPORTATION,
  AppointmentCancellationReason.CLINIC_CANCELLED,
  AppointmentCancellationReason.OTHER,
] as const

const primaryReasonDisplayTextNetwork: Record<(typeof networkCancellationReasons)[number], string> = {
  [AppointmentCancellationReason.NOT_MOVING_FORWARD]: i18next.t('pages.appointment.cancel.reason.network.notMovingForward'),
  [AppointmentCancellationReason.COST_INSURANCE]: i18next.t('pages.appointment.cancel.reason.network.costInsurance'),
  [AppointmentCancellationReason.PERSONAL_HEALTH]: i18next.t('pages.appointment.cancel.reason.network.personalHealth'),
  [AppointmentCancellationReason.TRAVEL_TRANSPORTATION]: i18next.t('pages.appointment.cancel.reason.network.travelTransportation'),
  [AppointmentCancellationReason.CLINIC_CANCELLED]: i18next.t('pages.appointment.cancel.reason.network.clinicCancelled'),
  [AppointmentCancellationReason.OTHER]: i18next.t('pages.appointment.cancel.reason.other'),
} as const

function getPrimaryCancellationReasons(country: Country, deliveryModel?: DeliveryModel): readonly string[] {
  if (country === Country.DE) return Object.values(PrimaryAppointmentCancellationReasonDE)
  if (deliveryModel && networkDeliveryModels.has(deliveryModel)) return networkCancellationReasons
  return Object.values(PrimaryAppointmentCancellationReason)
}

function getPrimaryCancellationReasonDisplayText(country: Country, deliveryModel?: DeliveryModel): Record<string, string> {
  if (country === Country.DE) return primaryReasonDisplayTextDE
  if (deliveryModel && networkDeliveryModels.has(deliveryModel)) return primaryReasonDisplayTextNetwork
  return primaryReasonDisplayText
}

const techSetupReasonDisplayText: Record<TechSetupFailureReason, string> = {
  TECH_SETUP_NOT_REACHED: 'Not reached',
  TECH_SETUP_TECHNICAL_DIFFICULTIES_EQUIPMENT: 'Technical difficulties (Equipment)',
  TECH_SETUP_TECHNICAL_DIFFICULTIES_INTERNET: 'Technical difficulties (Internet)',
  TECH_SETUP_TECHNICAL_TABLET_NOT_ARRIVED: 'Tablet not arrived',
} as const

export {
  getPrimaryCancellationReasonDisplayText,
  getPrimaryCancellationReasons,
  PrimaryAppointmentCancellationReason,
  PrimaryAppointmentCancellationReasonDE,
  primaryReasonDisplayText as primaryAppointmentCancellationReasonDisplayText,
  techSetupReasonDisplayText,
}
